module.exports = __webpack_public_path__ + "img/logo.b85587f2.png";